import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Grid, Typography } from "@material-ui/core"

const CircularProgressView = (props) => {
	const useStyles = makeStyles((theme) => ({
		progressContainer: {
			width: "250px",
			height: "250px",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
		},

		fullCircle: {
			fill: "transparent",
			stroke: theme.palette.progressCircle.full,
		},
		progressCircle: {
			fill: "transparent",
			stroke: theme.palette.progressCircle.progress,
		},
		circleText: {
			fill: theme.palette.grey.D100,
			fontSize: "32px",
		},
	}))
	const classes = useStyles()
	const { percent = 0, circleWidth = 250, strokeWidth = "5px", label } = props

	const radius = 100
	const circumference = 2 * Math.PI * radius
	const offset = circumference - (percent * circumference) / 100

	return (
		<Grid item className={classes.progressContainer}>
			<svg className={classes.circularSvg} width={circleWidth} height={circleWidth} viewBox={`0 0 ${circleWidth} ${circleWidth}`}>
				<circle className={classes.fullCircle} r={radius} cx={circleWidth / 2} cy={circleWidth / 2} strokeWidth={strokeWidth} />
				<circle
					className={classes.progressCircle}
					r={radius}
					cx={circleWidth / 2}
					cy={circleWidth / 2}
					strokeWidth={strokeWidth}
					strokeDasharray={circumference}
					strokeDashoffset={offset}
					transform={`rotate(-90 ${circleWidth / 2} ${circleWidth / 2})`}
				/>
				<text x="50%" y="50%" className={classes.circleText} dx="0.2em" dy="0.3em" textAnchor="middle">
					{`${percent} %`}
				</text>
			</svg>
			<Typography variant="body1" component="p" className={classes.progressLabel}>
				{label}
			</Typography>
		</Grid>
	)
}

export default CircularProgressView
